/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const SliderCardFragment = {
  SliderCard: gql`
    fragment SliderCardQuery on sliderCard_Entry {
      displayAllCardsMobile
      lineBreak_content
      lineBreak_styles
      slidesCards {
        ... on slidesCardsBlock_Entry {
          slideButtonLabel
          slideButtonLink
          slideButtonNewTab
          slideButtonNofollow
          slideButtonStyle
          slideContent {
            html
          }
          slideImage {
            url
            ... on images_Asset {
              altText
            }
          }
        }
      }
      sliderDescription
      sliderTitle
      styles
      typeHandle
    }
  `,
};
